import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { backend } from '../config/environment';
import cookies from "react-cookies";

const httpLink = createHttpLink({
  uri: backend.HTTP_URI,
});

const authLink = setContext((_, { headers }) => {
  const token = cookies.load("token");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
